import React from "react";

import { useSelector } from "react-redux";

import { ModalAddShortCut } from "./modal-add-shortcuts";
import { DraggableShortcuts } from "./draggable-shortcuts";
import { useFetchData } from "hooks/useFetchData";
import { Shortcut } from "./shortcut";

import "./style.scss";

export interface INavbarData {
    navBar: IShortcut[];
}

export interface IShortcut {
    url: string;
    label: string;
    icon?: string;
}

export const NavbarShortcuts = (props) => {
    const isEditable = useSelector((state) => state.dashboard.isEditable);

    const { data, setData } = useFetchData<INavbarData[]>({ url: "nav-bar" });

    const navbar = data?.[0]?.navBar;

    return (
        <>
            {!isEditable ? (
                <>
                    {navbar?.map((shortcut, index) => (
                        <Shortcut key={index} url={shortcut.url} label={shortcut.label} icon={shortcut.icon} />
                    ))}
                </>
            ) : (
                <>
                    <DraggableShortcuts navbar={navbar} setNavbarData={setData} />
                    <ModalAddShortCut navbar={navbar} setNavbarData={setData} />
                </>
            )}
        </>
    );
};
